var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Nova Reserva")]),_c('hr'),_c('ImovelForm',{on:{"salvar":_vm.salvaImovel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }